import { render, staticRenderFns } from "./agenda_asesor_capacitaciones.vue?vue&type=template&id=6aa60595"
import script from "./agenda_asesor_capacitaciones.vue?vue&type=script&lang=js"
export * from "./agenda_asesor_capacitaciones.vue?vue&type=script&lang=js"
import style0 from "./agenda_asesor_capacitaciones.vue?vue&type=style&index=0&id=6aa60595&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports